import { Button, IconButton, MenuItem, Tooltip, Typography } from '@mui/material';
import { Remove } from '@mui/icons-material';
import { Menu, MenuButton } from '@retail/components';
import { AssortmentTag } from '@retail/my-assortment/types';
import { useProductsTFunction } from '@retail/products/i18n';

interface Props {
  assortmentTags: AssortmentTag[];
  tooltip?: string;
  handleRemoveTag: (tagId: number) => void;
}

export function RemoveTagMenu({ assortmentTags, tooltip, handleRemoveTag }: Props) {
  const t = useProductsTFunction();

  return (
    <Menu>
      {({ onClose }) => (
        <>
          <Tooltip title={tooltip ?? ''}>
            <MenuButton component={IconButton} sx={{ padding: 0 }}>
              <Remove fontSize="small" />
            </MenuButton>
          </Tooltip>
          {assortmentTags.length === 0 ? (
            <MenuItem disabled>
              <Typography variant="body3">{t('products.mgItem.assortmentTags.noTags')}</Typography>
            </MenuItem>
          ) : (
            assortmentTags.map((tag) => (
              <MenuItem
                key={tag.id}
                LinkComponent={Button}
                onClick={() => {
                  handleRemoveTag(tag.id);
                  onClose();
                }}
              >
                {tag.name}
              </MenuItem>
            ))
          )}
        </>
      )}
    </Menu>
  );
}
